import React from "react";
import { Button } from "@sscs/ui";
import { prettifyLargeCount } from "@sscs/utils";
import styles from "./countBadge.module.scss";
const CountBadge = ({ count, label, plural = label, severity = "low", onClick, }) => {
    const badgeContent = (React.createElement(React.Fragment, null,
        React.createElement("span", null, plural && count > 0 ? plural : label),
        React.createElement("span", { className: styles[severity] }, prettifyLargeCount(count))));
    if (onClick) {
        return (React.createElement(Button, { variant: "text", isInline: true, className: styles["button-badge"], onClick: onClick }, badgeContent));
    }
    else {
        return React.createElement("div", { className: styles.root }, badgeContent);
    }
};
export default CountBadge;
//# sourceMappingURL=CountBadge.js.map